import { ToastOptions } from 'react-toastify';

export const detailedToastOptions: ToastOptions = {
  autoClose: false,
  closeButton: true,
  position: 'top-right',
  style: {
    maxHeight: 'unset',
    borderRadius: 6,
    top: 80,
  },
};
